import { createAction, props } from '@ngrx/store';
import { Split } from '../../models/split.model';
import { PaginationState } from '../../models/stock.model';

// Load Splits
export const loadSplits = createAction(
  '[Splits] Load Splits',
  props<{ stockId?: string; filters?: { pageNumber?: number; pageSize?: number } }>()
);
export const loadSplitsSuccess = createAction(
  '[Splits] Load Splits Success',
  props<{ splits: Split[]; pagination: PaginationState }>()
);
export const loadSplitsFailure = createAction(
  '[Splits] Load Splits Failure',
  props<{ error: any }>()
);

// Load Single Split
export const loadSplit = createAction('[Splits] Load Split', props<{ id: string }>());
export const loadSplitSuccess = createAction(
  '[Splits] Load Split Success',
  props<{ split: Split }>()
);
export const loadSplitFailure = createAction(
  '[Splits] Load Split Failure',
  props<{ error: any }>()
);

// Create Split
export const createSplit = createAction('[Splits] Create Split', props<{ split: Split }>());
export const createSplitSuccess = createAction(
  '[Splits] Create Split Success',
  props<{ split: Split }>()
);
export const createSplitFailure = createAction(
  '[Splits] Create Split Failure',
  props<{ error: any }>()
);

// Update Split
export const updateSplit = createAction(
  '[Splits] Update Split',
  props<{ id: string; split: Split }>()
);
export const updateSplitSuccess = createAction(
  '[Splits] Update Split Success',
  props<{ split: Split }>()
);
export const updateSplitFailure = createAction(
  '[Splits] Update Split Failure',
  props<{ error: any }>()
);

// Delete Split
export const deleteSplit = createAction('[Splits] Delete Split', props<{ id: string }>());
export const deleteSplitSuccess = createAction(
  '[Splits] Delete Split Success',
  props<{ id: string }>()
);
export const deleteSplitFailure = createAction(
  '[Splits] Delete Split Failure',
  props<{ error: any }>()
);
